import { defineMessages } from 'react-intl';

export default defineMessages({
  pageExpired: {
    id: 'globalUserMessage.pageExpired',
    defaultMessage: 'The page is expired and is automatically refreshed.',
  },
  productNotExist: {
    id: 'globalUserMessage.productNotExist',
    defaultMessage: 'Could not find the product. Try product search.',
  },
});
